export const iconFontAwesomeUsersPeopleBed = (
	<i className="fa-solid fa-bed"></i>
);
